// // XNGAGE CONFIDENTIAL
// // __________________________
// //
// // Copyright (C) 2023 Xngage - All Rights Reserved
// //
// // All code or information contained herein is, and remains the
// // property of Xngage LLC and its customers.  The intellectual
// // and technical concepts contained are proprietary to Xngage LLC
// // and may be covered by U.S. and Foreign Patents, patents in
// // process, and are protected by trade secret or copyright law.
// // Dissemination of this information or reproduction of this material
// // is strictly forbidden unless prior written permission is obtained
// // from Xngage LLC.
// //

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {chain,DispatchSetInitialValues} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";

export const SetInitialPhoneNumber: typeof DispatchSetInitialValues = props => {
    props.dispatch({
        type: "xAccountSettings/UpdatePhoneNumber",
        phone: props.getState().pages.accountSettings.editingAccount?.properties.phone,
    } as any);
};

addToChainAfter(chain, DispatchSetInitialValues, SetInitialPhoneNumber);
